// import React, { useEffect } from 'react';
// import { useLocation } from 'react-router-dom';
// import {
//     Box,
//     Typography,
//     Paper,
//     Button,
//     Grid,
//     Container,
// } from '@mui/material';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import ErrorIcon from '@mui/icons-material/Error';
// import axios from 'axios';
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { ToastContainer } from "react-toastify";

// const PaymentSuccess = () => {

//     console.log("location from payment data", useLocation());
//     const query = new URLSearchParams(useLocation().search);
//     console.log('querysuccess',query)
//     const paymentId = query.get('payment_id');
//     console.log(paymentId,'paymentId success')
//     const status = query.get('payment_status');


//     useEffect(() => {

//         const fetchData = async () => {
//             console.log("payment ", paymentId);

//             try {
//                 const response = await axios.get(
//                     `${process.env.REACT_APP_API_URL}Payment/GetPaymentDetails/${paymentId}`, {
//                     "PaymentReference": String(paymentId)
//                 },
//                     {
//                         headers: {
//                             'Content-Type': 'application/json',
//                             'Authorization': 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJWYWxpZElzc3VlciI6IlByYXN5c3QiLCJWYWxpZEF1ZGllbmNlIjoiUHJhc3lzdCJ9.gMMGQ74cWLoymeDv0D4c3UQKTEJSCzdkXoxlW4qF5QU'
//                         },
//                     }
//                 );

//                 console.log("response 444", response);
//                 let obj = response.data;
//                 if (response.status === 200) {
//                     let payload = {
//                         "ResidentId": obj.phone,
//                         "id": obj.id,
//                         "title": obj.title,
//                         "payment_type": obj.payment_type,
//                         "payment_request": obj.payment_request,
//                         "status": obj.status,
//                         "link": "http://paymentlink.com",
//                         "product": "product_name",
//                         "seller": obj.seller,
//                         "currency": obj.currency,
//                         "amount": obj.amount,
//                         "name": obj.name,
//                         "email": obj.email,
//                         "phone": obj.phone,
//                         "payout": "50.00",
//                         "fees": "2.00",
//                         "total_taxes": "5.00",
//                         "cases": "case_123",
//                         "affiliate_id": "affiliate_123",
//                         "affiliate_commission": "10.00",
//                         "instrument_type": obj.instrument_type,
//                         "billing_instrument": obj.billing_instrument,
//                         "failure": obj.failure.message,
//                         "bank_reference_number": obj.bank_reference_number,
//                         "created_at": obj.created_at,
//                         "updated_at": obj.updated_at,
//                         "completed_at": obj.completed_at,
//                         "tax_invoice_id": obj.tax_invoice_id,
//                         "resource_uri": obj.resource_uri

//                     }

//                     console.log("payload payment insert", payload);
//                     await InsertData(payload)
//                 }
//             } catch (error) {
//                 console.error('Error making payment request:', error);
//             }
//         }




//         fetchData();

//     }, [])



//     const InsertData = async (payload) => {
              
//         try {
//             const response = await axios.post(
//               `${process.env.REACT_APP_API_URL}PaymentGatewayLog/InsertPaymentGatewayLog`,
//               payload,
//               {
//                 headers: {
//                   'Content-Type': 'application/json',
//                   Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJWYWxpZElzc3VlciI6IlByYXN5c3QiLCJWYWxpZEF1ZGllbmNlIjoiUHJhc3lzdCJ9.gMMGQ74cWLoymeDv0D4c3UQKTEJSCzdkXoxlW4qF5QU',
//                 },
//               }
//             );
      
//             console.log(response); 
//             if(response.data.Status === 0){
//                  toast.success(response.data.Message);
//             }
          
//           } catch (error) {
//             console.error('Error making payment request:', error);
    
//           }
//     }

//     return (
       
//         <Container maxWidth="md" sx={{ marginTop: 6 }}>
//         <ToastContainer />
//             <Paper elevation={3} sx={{ padding: 4, borderRadius: 2 }}>
//                 <Box
//                     display="flex"
//                     flexDirection="column"
//                     alignItems="center"
//                     justifyContent="center"
//                     textAlign="center"
//                 >
//                     {status === 'Credit' ? (
//                         <>
//                             <CheckCircleIcon
//                                 sx={{
//                                     fontSize: 80,
//                                     color: 'green',
//                                     marginBottom: 2,
//                                 }}
//                             />
//                             <Typography variant="h4" gutterBottom>
//                                 Payment Successful
//                             </Typography>
//                             <Typography variant="body1">
//                                 Thank you! Your payment has been processed successfully.
//                             </Typography>
//                             {paymentId && (
//                                 <Typography variant="body2" sx={{ marginTop: 2 }}>
//                                     Payment ID: <strong>{paymentId}</strong>
//                                 </Typography>
//                             )}
//                         </>
//                     ) : (
//                         <>
//                             <ErrorIcon
//                                 sx={{
//                                     fontSize: 80,
//                                     color: 'red',
//                                     marginBottom: 2,
//                                 }}
//                             />
//                             <Typography variant="h4" gutterBottom>
//                                 Payment Failed
//                             </Typography>
//                             <Typography variant="body1">
//                                 Sorry, your payment could not be processed. Please try again or contact support.
//                             </Typography>
//                             {paymentId && (
//                                 <Typography variant="body2" sx={{ marginTop: 2 }}>
//                                     Reference ID: <strong>{paymentId}</strong>
//                                 </Typography>
//                             )}
//                         </>
//                     )}
//                     <Box sx={{ marginTop: 4 }}>
//                         <Button
//                             variant="contained"
//                             size="large"
//                             sx={{
//                                 backgroundColor: status === 'Credit' ? 'green' : 'red',
//                                 color: '#fff',
//                                 '&:hover': {
//                                     backgroundColor: status === 'Credit' ? 'darkgreen' : 'darkred',
//                                 },
//                             }}
//                             href="/payment"
//                         >
//                             {status === 'Credit' ? 'Go to Dashboard' : 'Retry Payment'}
//                         </Button>
//                     </Box>
//                 </Box>
//             </Paper>
//         </Container>
      
//     );
// };

// export default PaymentSuccess;


import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
    Box,
    Typography,
    Paper,
    Button,
    Grid,
    Container,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import axios from 'axios';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

const PaymentSuccess = () => {
    const query = new URLSearchParams(useLocation().search);
    console.log('querysuccess', query)
    const paymentId = query.get('payment_id');
    const status = query.get('payment_status');
     const UserId = sessionStorage.getItem("UserId");
    useEffect(() => {
        const fetchData = async () => {
            console.log("payment ", paymentId);

            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_API_URL}Payment/GetPaymentDetails/${paymentId}`,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJWYWxpZElzc3VlciI6IlByYXN5c3QiLCJWYWxpZEF1ZGllbmNlIjoiUHJhc3lzdCJ9.gMMGQ74cWLoymeDv0D4c3UQKTEJSCzdkXoxlW4qF5QU'
                        },
                    }
                );

                console.log("response 444", response);
                let obj = response.data;
                
                if (response.status === 200 && obj.id) {
                    if (obj.status === true) {
                        let payload = {
                            "ResidentId": 1, 
                            "MobileNo": obj.phone ? obj.phone.replace('+91', '').replace('+', '') : '', // Remove country code if present
                            "id": obj.id,
                            "title": obj.title || '',
                            "payment_type": obj.payment_type || '',
                            "payment_request": obj.payment_request || '',
                            "status": "True", 
                            "link": obj.link || "http://paymentlink.com",
                            "product": obj.product || "product_name",
                            "seller": obj.seller || '',
                            "currency": obj.currency || '',
                            "amount": obj.amount || '',
                            "name": obj.name || '',
                            "email": obj.email || '',
                            "phone": obj.phone || '',
                            "payout": obj.payout || "50.00",
                            "fees": obj.fees || "2.00",
                            "total_taxes": obj.total_taxes || "5.00",
                            "cases": Array.isArray(obj.cases) && obj.cases.length > 0 ? obj.cases.join(',') : "case_123", // Handle empty array
                            "affiliate_id": obj.affiliate_id || "affiliate_123",
                            "affiliate_commission": obj.affiliate_commission || "10.00",
                            "instrument_type": obj.instrument_type || '',
                            "billing_instrument": obj.billing_instrument || '',
                            "failure": obj.failure ? (obj.failure.message || obj.failure) : "None", // Handle null failure
                            "bank_reference_number": obj.bank_reference_number || '',
                            "created_at": obj.created_at || '',
                            "updated_at": obj.updated_at || '',
                            "completed_at": obj.completed_at || '',
                            "tax_invoice_id": obj.tax_invoice_id || '',
                            "resource_uri": obj.resource_uri || ''
                        }

                        console.log("payload payment insert", payload);
                        await InsertData(payload);
                    } else {
                        console.log("Payment not successful, status:", obj.status);
                        toast.error('Payment was not successful');
                    }
                }
            } catch (error) {
                console.error('Error making payment request:', error);
                toast.error('Error fetching payment details');
            }
        }

        if (paymentId) {
            fetchData();
        }
    }, [paymentId]) 

    const InsertData = async (payload) => {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}PaymentGatewayLog/InsertPaymentGatewayLog`,
                payload,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJWYWxpZElzc3VlciI6IlByYXN5c3QiLCJWYWxpZEF1ZGllbmNlIjoiUHJhc3lzdCJ9.gMMGQ74cWLoymeDv0D4c3UQKTEJSCzdkXoxlW4qF5QU',
                    },
                }
            );

            console.log(response);
            if (response.data.Status === 0) {
                toast.success(response.data.Message);
            try {
                const todayDate = new Date().toLocaleDateString();

                const emailPayload = {
                    PropId: 1, 
                    UserId: UserId, 
                    ToEmail: payload.email, 
                    Subject: `Payment Successful - Transaction ID: ${payload.id}`,
                    ImgFolderNm: payload.id,
                    Body: `Dear <strong>${payload.name}</strong>,<br><br>
                        Thank you for your payment! We're delighted to inform you that your transaction was successful.<br><br>
                        
                        <strong>Payment Confirmation Details:</strong><br><br>
                        
                        <table style="width: 100%; border-collapse: collapse;">
                            <tr>
                                <td style="padding: 8px; border: 1px solid #ddd; background-color: #f9f9f9;"><strong>Transaction ID</strong></td>
                                <td style="padding: 8px; border: 1px solid #ddd;">${payload.id}</td>
                            </tr>
                            <tr>
                                <td style="padding: 8px; border: 1px solid #ddd; background-color: #f9f9f9;"><strong>Amount Paid</strong></td>
                                <td style="padding: 8px; border: 1px solid #ddd;">${payload.currency} ${payload.amount}</td>
                            </tr>
                            <tr>
                                <td style="padding: 8px; border: 1px solid #ddd; background-color: #f9f9f9;"><strong>Payment Date</strong></td>
                                <td style="padding: 8px; border: 1px solid #ddd;">${todayDate}</td>
                            </tr>
                            <tr>
                                <td style="padding: 8px; border: 1px solid #ddd; background-color: #f9f9f9;"><strong>Payment Method</strong></td>
                                <td style="padding: 8px; border: 1px solid #ddd;">${payload.billing_instrument || 'Online Payment'}</td>
                            </tr>
                            <tr>
                                <td style="padding: 8px; border: 1px solid #ddd; background-color: #f9f9f9;"><strong>Status</strong></td>
                                <td style="padding: 8px; border: 1px solid #ddd; color: green; font-weight: bold;">Successfully Completed</td>
                            </tr>
                        </table>
                        <br>
                        
                        We truly appreciate your business and prompt payment. This email serves as your receipt for the transaction.<br><br>
                        
                        If you have any questions about your payment or need further assistance, please don't hesitate to contact our support team at <strong>support@clanbridge.com</strong>.<br><br>
                        
                        Thank you for choosing our services!<br><br>
                        
                        Best regards,<br>
                        <strong>The Clanbridge Team</strong>`,
                    DocAttachments: [] 
                };
                
                const emailResponse = await axios.post(
                    `${process.env.REACT_APP_API_URL}EmailRequest/SendEmail`,
                    emailPayload,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJWYWxpZElzc3VlciI6IlByYXN5c3QiLCJWYWxpZEF1ZGllbmNlIjoiUHJhc3lzdCJ9.gMMGQ74cWLoymeDv0D4c3UQKTEJSCzdkXoxlW4qF5QU',
                        },
                    }
                );
                
                if (emailResponse.data.Status === 0 && emailResponse.data.responseStatusCode === 1) {
                    toast.success("Confirmation email sent successfully!");
                } else {
                    toast.error(emailResponse.data.Message || "Failed to send confirmation email");
                }
            } catch (emailError) {
                console.error('Error sending email:', emailError);
                toast.error('Error sending confirmation email');
            }
        } else {
            toast.error(response.data.Message || 'Payment log insertion failed');
        }

        } catch (error) {
            console.error('Error making payment log request:', error);
            toast.error('Error saving payment details');
        }
    }

    return (
        <Container maxWidth="md" sx={{ marginTop: 6 }}>
            <ToastContainer />
            <Paper elevation={3} sx={{ padding: 4, borderRadius: 2 }}>
                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                    textAlign="center"
                >
                    {status === 'Credit' ? (
                        <>
                            <CheckCircleIcon
                                sx={{
                                    fontSize: 80,
                                    color: 'green',
                                    marginBottom: 2,
                                }}
                            />
                            <Typography variant="h4" gutterBottom>
                                Payment Successful
                            </Typography>
                            <Typography variant="body1">
                                Thank you! Your payment has been processed successfully.
                            </Typography>
                            {paymentId && (
                                <Typography variant="body2" sx={{ marginTop: 2 }}>
                                    Payment ID: <strong>{paymentId}</strong>
                                </Typography>
                            )}
                        </>
                    ) : (
                        <>
                            <ErrorIcon
                                sx={{
                                    fontSize: 80,
                                    color: 'red',
                                    marginBottom: 2,
                                }}
                            />
                            <Typography variant="h4" gutterBottom>
                                Payment Failed
                            </Typography>
                            <Typography variant="body1">
                                Sorry, your payment could not be processed. Please try again or contact support.
                            </Typography>
                            {paymentId && (
                                <Typography variant="body2" sx={{ marginTop: 2 }}>
                                    Reference ID: <strong>{paymentId}</strong>
                                </Typography>
                            )}
                        </>
                    )}
                    <Box sx={{ marginTop: 4 }}>
                        <Button
                            variant="contained"
                            size="large"
                            sx={{
                                backgroundColor: status === 'Credit' ? 'green' : 'red',
                                color: '#fff',
                                '&:hover': {
                                    backgroundColor: status === 'Credit' ? 'darkgreen' : 'darkred',
                                },
                            }}
                            href="/payment"
                        >
                            {status === 'Credit' ? 'Go to Dashboard' : 'Retry Payment'}
                        </Button>
                    </Box>
                </Box>
            </Paper>
        </Container>
    );
};

export default PaymentSuccess;